import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, fromEvent, Subject } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';

//Menu Bar
export interface Menu {
  headTitle?: string;
  title?: string;
  path?: string;
  icon?: string;
  type?: string;
  badgeClass?: string;
  badgeValue?: string;
  active?: boolean;
  children?: Menu[];
  Menusub?: boolean;
  role?:string[];
  permissions?: string[];
}


@Injectable({
  providedIn: 'root'
})
export class NavService implements OnDestroy {

  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

  public megaMenu: boolean = false;
  public megaMenuCollapse: boolean = window.innerWidth < 1199 ? true : false;
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  constructor(
    private router: Router
  ) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, 'resize').pipe(
      debounceTime(1000),
      takeUntil(this.unsubscriber)
    ).subscribe((evt: any) => {
      this.setScreenWidth(evt.target.innerWidth);
      if (evt.target.innerwidth < 991) {
        this.collapseSidebar = false;
        this.megaMenu = false;
      }

      if (evt.target.innerWidth < 1199) {
        this.megaMenuCollapse = true;
      }
    });
    if (window.innerWidth < 991) {
      this.router.events.subscribe(event => {
        this.collapseSidebar = false;
        this.megaMenu = false;
      })
    }
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  ngOnDestroy() {
    this.unsubscriber.next(true);
    this.unsubscriber.complete();
  }

  MENUITEMS: Menu[] = [
 
    {
      headTitle: 'Menu'
    },
    {
      path: '/sistema/inicio', title: 'Ordenes digitales', type: 'link', icon: 'description', active: true, role: ['Administrador','Facturador','rx-panoramica','ecografo', 'rx-periapical', 'tomografo','RX'], permissions: ['transacciones.ordenes.read_list']
    },
   
        {
      title: 'Subir Resultados', icon: 'upload_file', type: 'sub', active: false,
      role: ['Administrador', 'ecografo', 'rx-periapical', 'RX', 'rx-panoramica', 'tomografo', '1'],
      permissions: [
        'subir_resultados.ecografias',
        'subir_resultados.rx_periapical',
        'subir_resultados.rx_panoramica',
        'subir_resultados.tomografias',
        'subir_resultados.analisis_cefalometrico',
        'subir_resultados.tomografia_zip',
        'subir_resultados.rx_corporal_imagenes',
        'subir_resultados.rx_corporal_informes',
        'subir_resultados.informes_rx'
      ],
      children: [
        {
          path: '/sistema/ecografias', title: 'Ecografías', type: 'link', active: false, role: ['Administrador', 'ecografo'], permissions: ['subir_resultados.ecografias']
        },
        {
          path: '/sistema/periapical', title: 'RX Periapical', type: 'link', active: false, role: ['Administrador', 'rx-periapical', 'RX'], permissions: ['subir_resultados.rx_periapical']
        },
        {
          path: '/sistema/panoramica', title: 'RX Panorámica', type: 'link', active: false, role: ['Administrador', 'rx-panoramica', 'RX'], permissions: ['subir_resultados.rx_panoramica']
        },
        {
          path: '/sistema/tomografias-imagenes', title: 'Tomografías', type: 'link', active: false, role: ['Administrador', 'tomografo', 'RX'], permissions: ['subir_resultados.tomografias']
        },
        {
          path: '/sistema/analisis-cefa', title: 'Analisis Cefalometrico', type: 'link', active: false, role: ['Administrador', '1'], permissions: ['subir_resultados.analisis_cefalometrico']
        },
        {
          path: '/sistema/cargar-tomografia', title: 'Tomografia .zip', type: 'link', icon: 'description', active: false,role: ['Administrador','Facturador','RX'], permissions: ['subir_resultados.tomografia_zip']
        },
        {
          path: '/sistema/corporales-doctor', title: 'RX Corporal (Imágenes)', type: 'link', icon: 'description', active: false,role: ['Administrador','rx-corporal-imagenes'], permissions: ['subir_resultados.rx_corporal_imagenes']
        },
        {
          path: '/sistema/corporales', title: 'RX Corporal (Informes)', type: 'link', icon: 'description', active: false,role: ['Administrador','rx-corporal'], permissions: ['subir_resultados.rx_corporal_informes']
        },
        {
          path: '/sistema/informes-rx', title: 'Informes RX', type: 'link', icon: 'description', active: false, permissions: ['subir_resultados.informes_rx']
        },
      ]
    },
        {
      title: 'Transacciones', icon: 'receipt_long', type: 'sub', active: false,
      permissions: ['transacciones.descuentos.read_list', 'transacciones.documentos_electronicos.read_list', 'transacciones.ordenes_convenio.read_list', 'transacciones.notas_credito.read_list', 'transacciones.envio_masivo.read_list'],
      children: [
        {
          path: '/sistema/documentos-electronicos', title: 'Facturas Electrónicas', type: 'link', active: false,
          permissions: ['transacciones.documentos_electronicos.read_list']
        },
        {
          path: '/sistema/ordenes-convenio', title: 'Ordenes Convenio', type: 'link', active: false,
          permissions: ['transacciones.ordenes_convenio.read_list', 'transacciones.documentos_electronicos.read_list']
        },
        {
          path: '/sistema/notas-credito', title: 'Notas de Crédito', type: 'link', active: false,
          permissions: ['transacciones.notas_credito.read_list']
        },
        {
          path: '/sistema/envio-masivo', title: 'Envío Masivo SRI', type: 'link', active: false,
          permissions: ['transacciones.envio_masivo.read_list']
        },
        {
          path: '/sistema/descuentos', title: 'Descuentos', type: 'link', active: false,
          permissions: ['transacciones.descuentos.read_list']
        }
      
      ]
    },
        {
      title: 'Laboratorio',
      icon: 'biotech',
      type: 'sub',
      active: false,
      permissions: [
        'laboratorio.laboratorios.read',
        'laboratorio.proveedores_derivados.read',
        'laboratorio.informacion_pruebas.read',
        'laboratorio.resultados.read',
        'laboratorio.scanear_muestras.read',
        'laboratorio.estados_muestras.read'
      ],
      children: [
         {
          path: '/sistema/laboratorios/resultados',
          title: 'Resultados',
          type: 'link',
          active: false,
          permissions: ['laboratorio.resultados.read']
        },
        {
          path: '/sistema/laboratorios/scanear-muestras',
          title: 'Scanear Muestras',
          type: 'link',
          active: false,
          permissions: ['laboratorio.scanear_muestras.read']
        },
        {
          path: '/sistema/laboratorios/estados-muestras',
          title: 'Estados de muestras',
          type: 'link',
          active: false,
          permissions: ['laboratorio.estados_muestras.read']
        },
        {
          path: '/sistema/laboratorios',
          title: 'Proveedores (Derivados)',
          type: 'link',
          active: false,
          permissions: ['laboratorio.laboratorios.read']
        },
        {
          path: '/sistema/laboratorios/informacion-pruebas',
          title: 'Información pruebas',
          type: 'link',
          active: false,
          permissions: ['laboratorio.informacion_pruebas.read']
        },
       
      ]
    },
     {
      title: 'Gestión Clínica',
      icon: 'medical_services',
      type: 'sub',
      active: false,
      permissions: [
        'gestion_clinica.historia_clinica.read',
        'gestion_clinica.historial_pacientes.read'
      ],
      children: [
        {
          path: '/sistema/gestion-clinica/historia-clinica',
          title: 'Historia Clínica',
          type: 'link',
          active: false,
          permissions: ['gestion_clinica.historia_clinica.read']
        },
        {
          path: '/sistema/gestion-clinica/historial',
          title: 'Historial de Pacientes',
          type: 'link',
          active: false,
          permissions: ['gestion_clinica.historial_pacientes.read']
        }
      ]
    },
    {
      title: 'Ordenes Fisicas', icon: 'business_center', type: 'sub', active: false,
      role: ['Administrador', 'Facturador'],
      permissions: [
        'empresa.solicitudes_ordenes_fisicas.read',
        'empresa.tipo_precios.read',
        'empresa.precios_ordenes_fisicas.read'
      ],
      children: [
        {
          path: '/sistema/ordenes-fisicas-solicitudes', title: 'Solicitudes', type: 'link', active: false, role: ['Administrador', 'Facturador'], permissions: ['empresa.solicitudes_ordenes_fisicas.read']
        },
        {
          path: '/sistema/ordenes-fisicas-precios', title: 'precios', type: 'link', active: false, role: ['Administrador', 'Facturador'], permissions: ['empresa.precios_ordenes_fisicas.read']
        },
        {
          path: '/sistema/ordenes-fisicas-tipo-precios', title: 'Tipo de Blocks', type: 'link', active: false, role: ['Administrador', 'Facturador'], permissions: ['empresa.tipo_precios.read']
        }
      ]
    },

    {
      title: 'Administración',
      icon: 'admin_panel_settings',
      type: 'sub',
      active: false,
      permissions: [
        'empresa.solicitudes_precios_administracion.read'
      ],
      children: [
        {
          path: '/sistema/administracion-solicitud-precios',
          title: 'Solicitud precios',
          type: 'link',
          active: false,
          role: ['Administrador'],
          permissions: ['empresa.solicitudes_precios_administracion.read']
        }
      ]
    },
    {
      path: '/sistema/tomografias', title: 'Gestión Tomografías', type: 'link', icon: 'description', active: false, role: ['Administrador','Facturador','RX'], permissions: ['transacciones.requerimientos.read']
    },

   
 
   
    {
      path: '/sistema/crear-orden', title: 'Cotizar - Facturar', type: 'link', icon: 'description', active: false,role: ['Administrador','rx-corporal-imagenes', 'rx-corporal','rx-panoramica','ecografo', 'rx-periapical', 'tomografo'], permissions: ['transacciones.ordenes.create']
    },

    {
      title: 'Configuraciones',
      icon: 'tune',
      type: 'sub',
      active: false,
      permissions: ['empresa.configuracion.sellos_firmas.read'],
      children: [
        {
          path: '/sistema/sellos-firmas',
          title: 'Sellos / Firmas',
          type: 'link',
          active: false,
          permissions: ['empresa.configuracion.sellos_firmas.read']
        }
      ]
    },
    {
      title: 'Seguridad',
      icon: 'security',
      type: 'sub',
      active: false,
      permissions: [
        'empresa.perfiles_acceso.profiles.read',
        'admin.users.read',
        'empresa.seguridad.acceso_ip.manage'
      ],
      children: [
        {
          path: '/sistema/perfiles-acceso',
          title: 'Perfiles y permisos',
          type: 'link',
          active: false,
          permissions: ['empresa.perfiles_acceso.profiles.read']
        },
        {
          path: '/sistema/usuarios',
          title: 'Usuarios',
          type: 'link',
          active: false,
          permissions: ['admin.users.read']
        },
        {
          path: '/sistema/acceso-ip',
          title: 'Accesos IP',
          type: 'link',
          active: false,
          permissions: ['empresa.seguridad.acceso_ip.manage']
        }
      ]
    },
  ];

  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

}
